import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteChannelsGroup($id: ID!) {
  deleteGroupChannel(id: $id) {
    id
  }
}`;

function deleteChannelsGroup(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteGroupChannel);
}

export default deleteChannelsGroup;
